export const aciKey = {
    iconName: 'key',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M12.672 14.003l2.034-2.007 1.41.376a1.251 1.251 0 001.209-.376 1.261 1.261 0 00.296-1.191l-.376-1.4.656-.608 1.41.376a1.25 1.25 0 001.209-.376 1.263 1.263 0 00.304-1.183l-.376-1.4A1.882 1.882 0 0019.114 3c-.5 0-.98.198-1.333.552l-7.775 7.788a5.044 5.044 0 00-6.145 1.817 5.025 5.025 0 00.614 6.37 5.04 5.04 0 008.391-2.13 5.024 5.024 0 00-.194-3.394z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M7.34 18.186a1.52 1.52 0 10.002-3.041 1.52 1.52 0 00-.002 3.04z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
